"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDealSummaryValue = void 0;
var selectn_1 = __importDefault(require("selectn"));
var lodash_1 = require("lodash");
var getDealSummaryValue = function (dealSummaryData, propertyName) {
    if (dealSummaryData === void 0) { dealSummaryData = {}; }
    if (propertyName === void 0) { propertyName = 'dueAtSigning'; }
    if (Object.keys(dealSummaryData).length === 0 || !propertyName) {
        return;
    }
    return (0, selectn_1.default)('value', (0, lodash_1.find)(dealSummaryData, function (item) { return item.key === propertyName; }));
};
exports.getDealSummaryValue = getDealSummaryValue;
